import React, { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

/** Chain IDs used by DEX/Swap – names for sidebar badge */
export const CHAIN_NAMES: Record<number, string> = {
  1: 'Ethereum',
  10: 'Optimism',
  56: 'BNB Chain',
  100: 'Gnosis',
  137: 'Polygon',
  324: 'zkSync Era',
  42161: 'Arbitrum',
  43114: 'Avalanche',
  5000: 'Mantle',
  59144: 'Linea',
  81457: 'Blast',
  8453: 'Base',
  534352: 'Scroll',
};

type SelectedChainContextType = {
  selectedChainId: number | null;
  setSelectedChainId: (chainId: number | null) => void;
};

const SelectedChainContext = createContext<SelectedChainContextType | undefined>(undefined);

export const SelectedChainProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedChainId, setSelectedChainIdState] = useState<number | null>(null);
  const setSelectedChainId = useCallback((chainId: number | null) => {
    setSelectedChainIdState(chainId);
  }, []);
  return (
    <SelectedChainContext.Provider value={{ selectedChainId, setSelectedChainId }}>
      {children}
    </SelectedChainContext.Provider>
  );
};

export function useSelectedChain(): SelectedChainContextType {
  const ctx = useContext(SelectedChainContext);
  if (ctx === undefined) {
    return {
      selectedChainId: null,
      setSelectedChainId: () => {},
    };
  }
  return ctx;
}
